/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDeviceType } from 'app/shared/model/device-type.model';
import { IDeviceManufacurer } from 'app/shared/model/device-manufacurer.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IDevice {
  id?: string;
  code?: string | null;
  description?: string | null;
  implant?: boolean | null;
  name?: string | null;
  mfgCode?: string | null;
  riskClass?: string | null;
  slug?: string | null;
  country?: string | null;
  releaseDate?: number | null;
  updatedDate?: number | null;
  discontinued?: boolean | null;
  discontinuedDate?: number | null;
  mrp?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  classification?: IDeviceType | null;
  manufacturer?: IDeviceManufacurer | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IDevice> = {
  implant: false,
  discontinued: false,
  active: false,
};
